(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fk-global-style"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const showLogoTextFallback = (image) => {
      image.hidden = true;
      image.closest('.header-logo')?.classList.add('fk-logo-text-fallback');
    };

    const retryHeaderLogo = (image) => {
      const sourceValue = image.currentSrc || image.src;

      if (!sourceValue) {
        showLogoTextFallback(image);
        return;
      }

      const source = new URL(sourceValue, window.location.origin);
      const version = source.searchParams.get('v');
      source.search = '';

      if (version) source.searchParams.set('v', version);

      image.removeAttribute('srcset');
      image.addEventListener('error', () => showLogoTextFallback(image), { once: true });
      image.src = source.toString();
    };

    const prepareHeaderLogos = (root) => {
      const images = [];

      if (root instanceof Element && root.matches('.header-logo__image')) {
        images.push(root);
      }

      if ('querySelectorAll' in root) {
        images.push(...root.querySelectorAll('.header-logo__image'));
      }

      images.forEach((image) => {
        if (image.dataset.fkLogoPrepared === 'true') return;

        image.dataset.fkLogoPrepared = 'true';
        image.addEventListener('error', () => retryHeaderLogo(image), { once: true });

        if (image.complete && image.naturalWidth === 0) {
          retryHeaderLogo(image);
        }
      });
    };

    prepareHeaderLogos(document);

    const logoObserver = new MutationObserver((records) => {
      records.forEach((record) => {
        record.addedNodes.forEach((node) => {
          if (node instanceof Element) prepareHeaderLogos(node);
        });
      });
    });

    logoObserver.observe(document.body, {
      childList: true,
      subtree: true
    });

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    if (reducedMotion.matches || !('IntersectionObserver' in window)) return;

    const rules = [
      { selector: '.fk-home-hero__visual', direction: 'right' },
      { selector: '.fk-value-strip__item', direction: 'up', stagger: true },
      { selector: '.fk-category-navigation__card', direction: 'up', stagger: true },
      { selector: '.fk-b2b-panel__media', direction: 'left' },
      { selector: '.fk-b2b-panel__content', direction: 'right' },
      { selector: '[id*="section_VdMUrq"] .image-block', direction: 'left' },
      { selector: '[id*="section_VdMUrq"] .group-block', direction: 'right' },
      { selector: '.product-information .product-details', direction: 'right' },
      { selector: '.fk-product-description__header', direction: 'left' },
      { selector: '.fk-product-description__content', direction: 'right' },
      { selector: '[id*="section_eMiaGR"] .image-block', direction: 'left' },
      { selector: '[id*="section_eMiaGR"] .group-block', direction: 'right' },
      { selector: '.resource-list__item, .product-grid__item', direction: 'up', stagger: true }
    ];

    const observed = new WeakSet();
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('fk-reveal--visible');
        revealObserver.unobserve(entry.target);
      });
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -8% 0px'
    });

    const prepare = (element, direction, delay) => {
      if (!(element instanceof HTMLElement) || observed.has(element)) return;

      observed.add(element);
      element.classList.add('fk-reveal');

      if (direction === 'left' || direction === 'right') {
        element.classList.add(`fk-reveal--${direction}`);
      }

      element.style.setProperty('--fk-reveal-delay', `${delay}ms`);
      revealObserver.observe(element);
    };

    const scan = (root) => {
      rules.forEach((rule) => {
        const matches = [];

        if (root instanceof Element && root.matches(rule.selector)) {
          matches.push(root);
        }

        if ('querySelectorAll' in root) {
          matches.push(...root.querySelectorAll(rule.selector));
        }

        matches.forEach((element, index) => {
          const delay = rule.stagger ? Math.min((index % 4) * 110, 330) : 0;
          prepare(element, rule.direction, delay);
        });
      });
    };

    document.documentElement.classList.add('fk-motion-enabled');
    scan(document);

    const mutationObserver = new MutationObserver((records) => {
      records.forEach((record) => {
        record.addedNodes.forEach((node) => {
          if (node instanceof Element) scan(node);
        });
      });
    });

    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
